import React from "react";
import { View, Text, Image, Pressable } from "react-native";
import { useChatItem } from "./chat-item-provider";
import { format } from "date-fns";
import { useSetChatMetadata } from "./chat-metadata-provider";
import FileIcon from "@/assets/svgs/file-icon";
import { useSheet } from "../shared/sheet-provider";
import {
  DownloadStudyMaterialSheetPayload,
  DownloadStudyMaterialSheetResult,
} from "../sheets/download-study-material-sheet";
import { SheetIds } from "../utils/sheet-ids";

function ChatBubble() {
  const chatItem = useChatItem();
  const setChatMetadata = useSetChatMetadata();
  const isImage = !!(
    (chatItem.fileType)?.toLowerCase()?.includes("image") ||
    (chatItem.fileName)?.toLowerCase()?.includes(".jpg") ||
    (chatItem.fileName)?.toLowerCase()?.includes(".jpeg") ||
    (chatItem.fileName)?.toLowerCase()?.includes(".png")
  );
  const { open: openDownloadStudyMaterialSheet } = useSheet<
    DownloadStudyMaterialSheetPayload,
    DownloadStudyMaterialSheetResult
  >(SheetIds.DOWNLOAD_STUDY_MATERIAL_SHEET);

  return (
    <View className="gap-4">
      {chatItem.showDate && (
        <Text className="font-geologica-regular text-xs text-gray-500 text-center">
          {format(chatItem.createdAt, "dd MMMM")}
        </Text>
      )}
      <View
        className={`flex-row ${chatItem.isMe ? "justify-end" : "justify-start"} mx-6`}
      >
        <View
          className={`gap-1 max-w-[80%] ${chatItem.isMe ? "bg-teachLoop-accentPrimary" : "bg-gray-300"} rounded-2xl p-4 ${chatItem.isMe ? "rounded-br-none" : "rounded-bl-none"}`}
        >
          {!!chatItem.fileUrl &&
            (isImage ? (
              <Pressable
                onPress={() => {
                  setChatMetadata({
                    selectedImageUrl: chatItem.fileUrl ?? undefined,
                  });
                }}
              >
                <Image
                  source={{ uri: chatItem.fileUrl }}
                  className="h-[143px] w-[143px]"
                  resizeMode="contain"
                />
              </Pressable>
            ) : (
              <Pressable
                className="flex-row gap-2 items-center"
                disabled={!chatItem.fileUrl}
                onPress={() => {
                  if (chatItem.fileUrl) {
                    openDownloadStudyMaterialSheet({
                      fileName: chatItem.fileName ?? "",
                      url: chatItem.fileUrl,
                    });
                  }
                }}
              >
                <FileIcon
                  className="size-4"
                  pathClassName="stroke-teachLoop-accentPrimary"
                />
                <Text className={`text-sm flex-1 font-geologica-regular ${chatItem.isMe ? "text-white" : "text-teal-600"} underline`}>
                  {chatItem.fileName}
                </Text>
              </Pressable>
            ))}

          {!!chatItem.content && (
            <Text
              className={`${chatItem.isMe ? "text-white" : "text-teachLoop-textPrimary"} font-geologica-regular text-sm`}
            >
              {chatItem.content}
            </Text>
          )}
          <Text
            className={`font-geologica-regular text-2xs ${chatItem.isMe ? "text-gray-200" : "text-teachLoop-textPrimary"}  text-right`}
          >
            {format(chatItem.createdAt, "HH:mm")}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default ChatBubble;
